import styled, { css } from "styled-components";
import { ArweaveImage } from "../../components/ArweaveImage";
import { Flex } from "../../components/Grid";
import { IMAGE_SIZES } from "../../lib/constants";
import { smallScreen } from "../../lib/mediaQuery";

interface Props {
  imageUrl: string;
}

export const CreatorImage = ({ imageUrl }: Props) => {
  return (
    <CreatorImageContainer>
      <ArweaveImage
        fill
        sizes={IMAGE_SIZES}
        alt="Creator image"
        src={imageUrl}
        css={`
          z-index: 1;
          border-radius: 50%;
          object-fit: cover;
        `}
      />
    </CreatorImageContainer>
  );
};

export const CreatorContainer = styled(Flex)`
  position: relative;
  align-items: center;
  cursor: pointer;
  &[data-is-disabled="true"] {
    pointer-events: none;
    cursor: initial;
  }
`;

const CreatorImageContainer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  overflow: hidden;
  padding-bottom: 100%;
  outline: 0px solid transparent;
  outline-offset: 4px;
  border-radius: 50%;
  width: 100%;
  ${smallScreen(
    css`
      width: 100%;
      height: 100%;
    `
  )};

  ${CreatorContainer}:hover & {
    outline: 2px solid var(--focus-color);
    transition: outline-width var(--transition-speed-normal)
      var(--easing-standard);
  }
  [data-is-disabled="true"]:hover & {
    filter: none;
  }
`;
